/*
 * -----------------------------------------------------------------------
 *  <copyright file="steps-box/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import cn from 'clsx';
import React from 'react';
import 'views/components/core/steps-box/styles.scss';
import { DialogPage } from 'views/components/core/dialog';

interface StepsBoxProps {
    page: DialogPage;
    onChangeStep: (number: number, withoutNav?: boolean) => void;
    pageTitles: string[];
}

const StepsBox = ({ page, onChangeStep, pageTitles }: StepsBoxProps) => {
    const buttons: JSX.Element[] = [];

    for (let i = 0; i < page.available; i++) {
        const pageNumber = i + 1;
        const zIndex = 100 - 5 * i; // Count down zIndex in increments of 5, leaving space for other elements if necessary

        buttons.push(
            <button
                key={i}
                style={{ zIndex }}
                onClick={() => onChangeStep(pageNumber)}
                type="button"
                className={cn('btn-arrow-right', { first: pageNumber === 1, disabled: page.number === pageNumber })}
                data-testid={`steps-button-${pageNumber}`}
            >
                {pageTitles[i]}
            </button>,
        );
    }

    return <div className="steps-container">{buttons}</div>;
};

export default StepsBox;
